import { useQuery, useQueryClient } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const urlPrefix = "/plugins/org.graylog.plugins.archive";
const configUrl = () => qualifyUrl(`${urlPrefix}/config`);
export const ARCHIVE_CONFIGURATION_QUERY_KEY = ["archive-configuration"];
const errorMessageFor = (error) => {
  try {
    return error.additional.body.message;
  } catch (_e) {
    return error.message;
  }
};
export const fetchArchiveConfiguration = () => fetch("GET", configUrl()).catch((error) => {
  UserNotification.error(`Fetching config failed: ${errorMessageFor(error)}`, "Could not retrieve archive config");
  throw error;
});
export const saveArchiveConfiguration = (config) => fetch("PUT", configUrl(), config).then((response) => {
  UserNotification.success("Archive configuration was updated successfully");
  return response;
}).catch((error) => {
  UserNotification.error(
    `Updating archive config failed: ${errorMessageFor(error)}`,
    "Unable to update archive config"
  );
  throw error;
});
export const useInvalidateArchiveConfiguration = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ARCHIVE_CONFIGURATION_QUERY_KEY });
};
const useArchiveConfiguration = () => useQuery({
  queryKey: ARCHIVE_CONFIGURATION_QUERY_KEY,
  queryFn: fetchArchiveConfiguration,
  retry: false
});
export default useArchiveConfiguration;
